<template>
  <div class="all-cargos-type-component">
    <v-container>
      <div class="cargo-type-list" v-for="(cargoItem, index) in cargoItems" :key="index">
        <TransportFormCargoItem
          v-bind:cargoItem="cargoItem"
          v-bind:index="index"
          @remove-cargo="removeCargo"
          @clone-cargo="cloneCargo"
          :isEditable="isEditable"
        />
      </div>
      <v-btn v-if="isEditable" class="add_new_cargo_btn" outlined v-on:click="addCargo()">
        <v-icon color="kazan" left>add</v-icon>
        {{ $t('orders.add_another_item') }}
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'
import TransportFormCargoItem from '@/components/transportRequests/new/TransportFormCargoItem.vue'

export default {
  name: 'TransportFormCargo',
  components: {
    TransportFormCargoItem
  },
  props: {
    value: Array,
    isEditable: Boolean
  },
  data () {
    return {
      cargoItems: [...this.value]
    }
  },
  methods: {
    addCargo: function () {
      let newCargo = {
        ref: '',
        type: 'box',
        length: '',
        width: '',
        height: '',
        mesurmentUnit: 'cm',
        weight: '',
        weightUnit: 'kg',
        description: ''
      }
      this.cargoItems.push(newCargo)
    },
    removeCargo: function (index) {
      this.cargoItems.splice(index, 1)
    },
    cloneCargo: function (cargo) {
      this.cargoItems.push(Vue.util.extend({}, cargo))
    }
  },
  mounted () {
    if (this.cargoItems.length === 0) {
      this.addCargo()
    }
  },
  watch: {
    cargoItems: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
  .add_new_cargo_btn {
    border: 1px dashed grey !important;
  }
</style>
